<template>
	<templateLogin>
		<div class="header"></div>
		<div class="body">
			<section class="box-login">
				<form v-on:submit="doCheckToken" action="#" method="post">
					<div class="title ">
						<h1>{{title}}</h1>
						<p>{{text}}</p>
					</div>
					<div v-show="message.text"
						v-html="message.text"
						:class="{
							'message': message.type === 'error',
							'message-success': message.type === 'success',
							'mb-15': true
						}" />
					<div>
						<ui-confirm-code :size="4" v-model="form.token" border class="mb-25" />
					</div>
					
					<div class="text">
						Não receu o código?
						<button :loading="status === 'loading'"
							:disabled="timer"
							type="button"
							@click="resendToken">
							Tentar novamente <b v-if="timer">{{ timer }}</b>
						</button>
					</div>

					<div class="control">
						<ui-button :class="status"
							:loading="status === 'loading'"
							type="submit"
							design="lg primary block">
							Confirmar
						</ui-button>
					</div>

					<div class="back-link ">
						<router-link to="/login"><i class="fal fa-long-arrow-left"></i> Voltar</router-link>
					</div>
				</form>
			</section>
		</div>
	</templateLogin>
</template>
<script>
	import templateLogin from '@/templates/page-login'
	import { uiButton } from '@/components/ui/buttons'
	import { uiConfirmCode } from '@/components/ui'

	import { resetPassword } from '@/services/axios'

	export default {
		components: { templateLogin, uiButton, uiConfirmCode},

		data() {
			return {
				title: 'Confirmar Código',
				text: 'Informe o código que enviamos em seu celular.',
				message: {
					text: '',
					type: 'success'
				},
				status: '',
				data: {
					userID: null,
					email: ''
				},
				form: {
					token: '',
					countdown: ''
				},
			}
		},

		created(){
			this.data.userID = this.$route.params.user_id
			this.data.email = this.$route.params.email
		},

		computed: {
			timer: {
				get() {
					return this.form.countdown
				},
				set(value) {
					if (!value) return

					// Inicializa a data de contagem
					let countDownDate = new Date().add(5, 'm').getTime()
					// Atualiza o contador a cada 1s
					var x = setInterval(() => {
						// Busca a data e instante atual
						let now = new Date().getTime()
							
						// Calcula a diferença entre a data limite e a data atual
						let distance = countDownDate - now
							
						// Calcula os minutos e segundos
						let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
						let seconds = Math.floor((distance % (1000 * 60)) / 1000)
							
						// Seta o valor do contador
						this.form.countdown = minutes + ":" + seconds

						// Se a contagem está finalizada, apaga o contador
						if (distance < 0) {
							clearInterval(x)
							this.form.countdown = ''
						}
					}, 1000)
				}
			}
		},

		methods: {
			/**
			 * Solicita o reenvio do token de validação para o celular cadastrado
			 */
			resendToken() {
				this.status = 'loading'
				const params = {
					email: this.data.email,
					type: 'mobile'
				}

				resetPassword.recover(params).then(response => {
                    if (response.data.status !== "error") {
                        this.data.userID = response.data.data.user_id
                    }
					this.message = {
						text: response.data.msg,
						type: response.data.status
					}
                    this.status = false
					// Inicializa a contagem do timer
					this.timer = true
                })
			},
			/**
			 * Realiza uma requisição para validar o token de autenticaçao
			 */
			doCheckToken(event){
				event.preventDefault()
				this.status = 'loading'
				this.message = {
					text: '',
					type: 'success'
				}

				if (!this.form.token) {
					this.$refs.token.$el.classList.add('error')
					this.message = {
						text: 'Informe o token que enviamos via sms.',
						type: 'error'
					}
					this.status     = false
					return false
				}

				resetPassword.checkToken(this.data.userID, this.form.token)
					.then(response => {
						if (response.data == "" || response.data.status !== "error") {
							this.$router.push({
								name: 'registerNewPassword',
								params: {
									userID: this.data.userID,
									token: this.form.token
								}
							})
						}
						this.message = {
							text: response.data.msg,
							type: response.data.status
						}
						this.status = false
					})
					.catch(error => {
						this.message = {
							text: error.response.data.message,
							type: 'error'
						}
						console.log(error)
					})
			}
		}
	}
</script>
